

































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import Modal from '../../Modal/Base3.vue';
import Brand from '@/services/Brand';
import jQuery from 'jquery';
import BillPay from '@/services/BillPay';
import Alert from '@/components/Global/Card.vue';
import { PaymentSources } from '@/common/Payments';

@Component({
	name: 'VerifyPaymentMethod',
	components: {
		Modal,
		Alert,
	},
})
export default class VerifyPaymentMethod extends Vue {
	@Prop() private method: PaymentSources;
	@Prop() private admin: boolean;
	@Prop() private userId: string;
	@Prop() private selectedBrand: string;
	@Mutation('updatePaymentSource', { namespace: 'Payment' }) private updatePaymentSource: (
		payload,
	) => void;
	@Mutation('setPaymentSuccess', { namespace: 'Payment' }) private setPaymentSuccess: (
		payload,
	) => void;
	private error: boolean | string = false;
	private micro1: string = '';
	private micro2: string = '';
	private authorizedToSubmit: boolean = false;

	private created() {
		console.log(this.method);
	}

	private async verifyMethod() {
		try {
			console.log(this.method);
			console.log(this.method.id);
			// Push to Database
			let adminProps;
			if ( this?.admin === true ) {
				adminProps = {
					admin: true,
					userId: this.userId,
					brand: this.selectedBrand
				};
			}

			const verify = await BillPay.verifyBankAccount({
				id: this.method.id,
				deposit1: this.micro1,
				deposit2: this.micro2,
				...adminProps
			});
			console.log(verify);

			if (verify.status === 200) {
				if (verify.data.error) {
					this.error = verify.data.error;
					return;
				}
				this.method.verified = true;
				this.updatePaymentSource({ id: this.method.id, data: this.method });
				jQuery('#verifyPaymentMethod').modal('hide');
				this.setPaymentSuccess({ type: 'verify', status: true });

				if (this.method.type === 'bank_account') {
					console.log('test');
					this.$emit('update:alert', {
						type: 'success',
						title: 'Payment method added',
						msg: `Successfuly added - Bank Account ending in ${this.method.last4}`,
					});
				}
				this.resetModal();
				return;
			}

			this.error = 'There was an error trying to verify your bank account, please try again.';
		} catch (e) {
			this.error =
				'Sorry, there was some kind of error, if it continues, please contact support';
		}
	}

	private resetModal() {
		this.micro1 = '';
		this.micro2 = '';
	}

	private closeWindow() {
		jQuery('#verifyPaymentMethod').modal('hide');
	}
}
